export const roundDown = (num: number) => Math.floor(num * 100) / 100;
